import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tournament-info',
  templateUrl: './tournament-info.component.html',
  styleUrls: ['./tournament-info.component.scss']
})
export class TournamentInfoComponent implements OnInit {
  tournamentDetailData?;

  teamsCategories?;
  teamInitialsArray?;
  isLoading
  categories?

  constructor() {
    this.isLoading=false
    
    this.teamsCategories= [
      {
          "category": "A",
          "categoryLabelEn": "Category A",
          "categoryLabelAr": "تصنيف A",
          "teams": [
              {
                  "id": "7553",
                  "name": "51271-51272",
                  "category": "A",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "51271",
                      "mode": "viewer",
                      "name": "Ahmed AlEbrahim",
                      "initials": "AA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "fPhpG6kBXexMb",
                      "level": 0
                  },
                  "player2": {
                      "id": "51272",
                      "mode": "viewer",
                      "name": "Abdullah AlMishouti",
                      "initials": "AA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "XwIVuL3Ks2xYi",
                      "level": 0
                  }
              },
              {
                  "id": "7538",
                  "name": "51245-50341",
                  "category": "A",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "51245",
                      "mode": "viewer",
                      "name": "Aziz Mayouf",
                      "initials": "AM",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "08mWoyhrJCvFk",
                      "level": 0
                  },
                  "player2": {
                      "id": "50341",
                      "mode": "viewer",
                      "name": "J",
                      "initials": "J",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "P57zjdDw80qU6",
                      "level": 0
                  }
              },
              {
                  "id": "7539",
                  "name": "51246-51247",
                  "category": "A",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "51246",
                      "mode": "viewer",
                      "name": "Ahmed Ashour",
                      "initials": "AA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "D3staO4HdhqNG",
                      "level": 0
                  },
                  "player2": {
                      "id": "51247",
                      "mode": "viewer",
                      "name": "Khalifa AlMulla",
                      "initials": "KA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qhYUa0Tk1eVul",
                      "level": 0
                  }
              },
              {
                  "id": "7540",
                  "name": "51248-51249",
                  "category": "A",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "51248",
                      "mode": "viewer",
                      "name": "Ali Hayat",
                      "initials": "AH",
                      "picUrl": null,
                      "rank": "2",
                      "salt": "OQL3lx9Wp0VmE",
                      "level": 0
                  },
                  "player2": {
                      "id": "51249",
                      "mode": "viewer",
                      "name": "Humood AlJunaidel",
                      "initials": "HA",
                      "picUrl": null,
                      "rank": "2",
                      "salt": "dyCxDcgv0B6qY",
                      "level": 0
                  }
                }
          ]
      },
      {
          "category": "B",
          "categoryLabelEn": "Category B",
          "categoryLabelAr": "تصنيف B",
          "teams": [
              {
                  "id": "7298",
                  "name": "45461-46165",
                  "category": "B",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "45461",
                      "mode": "viewer",
                      "name": "Hussain Al Mussawi",
                      "initials": "HM",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGn9cPWK02",
                      "level": "5.5"
                  },
                  "player2": {
                      "id": "46165",
                      "mode": "viewer",
                      "name": "Mohammad Jawad Almazeedi",
                      "initials": "MA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGn9cPWK02",
                      "level": "5.3"
                  }
              },
              {
                  "id": "7261",
                  "name": "45202-50750",
                  "category": "B",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "45202",
                      "mode": "viewer",
                      "name": "Fawaz Almutairi",
                      "initials": "FA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGn9cPWK01",
                      "level": 2
                  },
                  "player2": {
                      "id": "50750",
                      "mode": "viewer",
                      "name": "Mohammad Alshatti",
                      "initials": "MA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "Vx0OPLlABrg2s",
                      "level": 8
                  }
                },
              {
                  "id": "7206",
                  "name": "45097-30200",
                  "category": "B",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "45097",
                      "mode": "viewer",
                      "name": "Faisal Bouqrais",
                      "initials": "FB",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGn9cPWK01",
                      "level": 8
                  },
                  "player2": {
                      "id": "30200",
                      "mode": "viewer",
                      "name": "Naser Al Obaidly",
                      "initials": "NO",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGK9cPWJ10",
                      "level": 0
                  }
              },
              {
                  "id": "7012",
                  "name": "47252-18000",
                  "category": "B",
                  "matchesPlayed": null,
                  "points": null,
                  "avgRank": 1,
                  "avgLevel": 0,
                  "player1": {
                      "id": "47252",
                      "mode": "viewer",
                      "name": "YOUSEF ALTEMEEMI",
                      "initials": "YA",
                      "picUrl": null,
                      "rank": "1",
                      "salt": "qiMaGn9cPWK03",
                      "level": 9
                  },
                  "player2": {
                      "id": "18000",
                      "mode": "viewer",
                      "name": "Abdulaziz alqaseer",
                      "initials": "AA",
                      "picUrl": null,
                      "rank": "4",
                      "salt": "0nwTm9iEoXHue",
                      "level": 0
                  }
                },
          ]
      },
  
  
  
  ]
  this.categories= [
          {
              "id": "126",
              "category": "A",
              "labelEn": "Category A",
              "labelAr": "تصنيف A",
              "totalSeats": "16",
              "availableSeats": 0,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "1"
          },
          {
              "id": "127",
              "category": "B",
              "labelEn": "Category B",
              "labelAr": "تصنيف B",
              "totalSeats": "26",
              "availableSeats": 6,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "2"
          },
          {
              "id": "128",
              "category": "C",
              "labelEn": "Category C",
              "labelAr": "تصنيف C",
              "totalSeats": "54",
              "availableSeats": -10,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "3"
          },
          {
              "id": "129",
              "category": "WA",
              "labelEn": "Women A",
              "labelAr": "نساء A\n",
              "totalSeats": "16",
              "availableSeats": 9,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "4"
          },
          {
              "id": "130",
              "category": "WB",
              "labelEn": "Women B",
              "labelAr": "نساء B\r\n",
              "totalSeats": "16",
              "availableSeats": 0,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "5"
          },
          {
              "id": "131",
              "category": "U16",
              "labelEn": "Juniors U16",
              "labelAr": "Juniors U16",
              "totalSeats": "12",
              "availableSeats": 1,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "6"
          },
          {
              "id": "132",
              "category": "U12",
              "labelEn": "Juniors U12 ",
              "labelAr": "Juniors U12 ",
              "totalSeats": "16",
              "availableSeats": 1,
              "price": "36.000",
              "ccy": "KWD",
              "sort": "7"
          }
      ]
   }

  ngOnInit(): void {

    this.addTeamInitialsArray()
  }

  addTeamInitialsArray=()=>{

    this.isLoading=true
    const teamsArray = [];

    this.teamsCategories.forEach(category => {
      category.teams.forEach(team => {
        teamsArray.push({
          team1: {avatar:team.player1.initials,
          name:team.player1.name},
          team2: {avatar:team.player2.initials,
            name:team.player2.name}
        });
      });
    });

    this.teamInitialsArray=teamsArray
    console.log('teamInitialsArray',teamsArray);
    this.isLoading=false

  }
}


// this.dummy={
//   "id": "61",
//   "ownerId": "1",
//   "federationId": "2",
//   "type": "T",
//   "nameEn": "PADEL IN TOUR | KUWAIT\nRock House Slider Arab Master",
//   "nameAr": "بادل ان تور - كويت\r\nRock House Slider Arab Master",
//   "descriptionEn": "Padel, double",
//   "descriptionAr": "بادل ثنائي",
//   "tournamentDescEn": "League",
//   "tournamentDescAr": "بطولة",
//   "tournamentTypeAr": "بادل",
//   "tournamentTypeEn": "Padel",
//   "tournamentType": "master",
//   "tournamentLogo": "https://i.ibb.co/xX9L2Zn/PHOTO-2023-12-06-16-37-53.jpg",
//   "tournamentIcon": null,
//   "country": "KW",
//   "level": "A, B, C, WA ,WB & Juniors",
//   "gender": "Male & Female ",
//   "feeAmount": "30.000",
//   "paid": "0",
//   "tournamentOpenFlag": true,
//   "registrationOpenFlag": false,
//   "standingsTabFlag": false,
//   "matchesTabFlag": true,
//   "requestCprInRegistration": "0",
//   "requestThreeName": "0",
//   "citizinResidentRequired": "0",
//   "registrationStartDate": "2023-12-06 16:00:00",
//   "registrationEndDate": "2023-12-10 18:00:00",
//   "fromDate": "2023-12-12 00:00:00",
//   "toDate": "2023-12-17 23:59:59",
//   "noOfGroups": "0",
//   "noOfTeamsPerGroup": "0",
//   "noOfRounds": "0",
//   "noOfQualifiedTeams": "1",
//   "noOfDisqualifiedTeams": "1",
//   "noOfTeams": "160",
//   "noOfTeamsJoined": "149",
//   "salt": "M5UFwxTF9wec99AO",
//   "socialType": null,
//   "socialRegistrationType": null,
//   "tournamentAnnouncementEn": null,
//   "tournamentAnnouncementAr": null,
//   "tournamentStatus": "live",
//   "status": "A",
//   "logDate": "2023-05-22 00:00:00",
//   "mode": "viewer",
//   "isPlayer": false,
//   "completeYourProfile": false,
//   "completeYourProfileFields": "",
//   "teamProfile": null,
//   "categories": [
//       {
//           "id": "126",
//           "category": "A",
//           "labelEn": "Category A",
//           "labelAr": "تصنيف A",
//           "totalSeats": "16",
//           "availableSeats": 0,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "1"
//       },
//       {
//           "id": "127",
//           "category": "B",
//           "labelEn": "Category B",
//           "labelAr": "تصنيف B",
//           "totalSeats": "26",
//           "availableSeats": 6,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "2"
//       },
//       {
//           "id": "128",
//           "category": "C",
//           "labelEn": "Category C",
//           "labelAr": "تصنيف C",
//           "totalSeats": "54",
//           "availableSeats": -10,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "3"
//       },
//       {
//           "id": "129",
//           "category": "WA",
//           "labelEn": "Women A",
//           "labelAr": "نساء A\n",
//           "totalSeats": "16",
//           "availableSeats": 9,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "4"
//       },
//       {
//           "id": "130",
//           "category": "WB",
//           "labelEn": "Women B",
//           "labelAr": "نساء B\r\n",
//           "totalSeats": "16",
//           "availableSeats": 0,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "5"
//       },
//       {
//           "id": "131",
//           "category": "U16",
//           "labelEn": "Juniors U16",
//           "labelAr": "Juniors U16",
//           "totalSeats": "12",
//           "availableSeats": 1,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "6"
//       },
//       {
//           "id": "132",
//           "category": "U12",
//           "labelEn": "Juniors U12 ",
//           "labelAr": "Juniors U12 ",
//           "totalSeats": "16",
//           "availableSeats": 1,
//           "price": "36.000",
//           "ccy": "KWD",
//           "sort": "7"
//       }
//   ],
//   "points": [],
//   "prizes": false,
//   "badges": false,
//   "schedules": [
//       {
//           "id": "201",
//           "labelEn": "Tuesday",
//           "labelAr": "الثلاثاء",
//           "startTime": "04:30 PM",
//           "endTime": "10:30 PM"
//       },
//       {
//           "id": "196",
//           "labelEn": "Wednesday",
//           "labelAr": "الأربعاء",
//           "startTime": "04:30 PM",
//           "endTime": "10:30 PM"
//       },
//       {
//           "id": "197",
//           "labelEn": "Thursday",
//           "labelAr": "الخميس",
//           "startTime": "04:30 PM",
//           "endTime": "10:30 PM"
//       },
//       {
//           "id": "198",
//           "labelEn": "Friday",
//           "labelAr": "الجمعة",
//           "startTime": "01:30 PM",
//           "endTime": "10:30 PM"
//       },
//       {
//           "id": "199",
//           "labelEn": "Saturday",
//           "labelAr": "السبت",
//           "startTime": "01:00 PM",
//           "endTime": "9:30 PM"
//       },
//       {
//           "id": "200",
//           "labelEn": "Sunday",
//           "labelAr": "الاحد",
//           "startTime": "04:30 PM",
//           "endTime": "09:00 PM"
//       }
//   ],
//   "courts": [
//       {
//           "id": "150",
//           "nameEn": "Padel In Kuwait",
//           "nameAr": "بادل ان الكويت",
//           "cityEn": "Kuwait",
//           "cityAr": "الكويت",
//           "longitude": "48.0650612",
//           "latitude": "29.2909778",
//           "startTime": "00:00:00",
//           "endTime": "00:00:00",
//           "ccy": "KWD",
//           "water": "1",
//           "rackets": "1",
//           "balls": "1",
//           "indoor": "1",
//           "bibs": "0",
//           "toilets": "1",
//           "showers": "1",
//           "outdoor": "0",
//           "private": "0",
//           "taxPercentage": "0",
//           "isNew": "1",
//           "isBusy": "0",
//           "isClosed": "0",
//           "callContactNumber": "96599957523",
//           "whatsappContactNumber": "96599957523",
//           "facilityIBAN": "KW36BBYN0000000000000735648001",
//           "logoUrl": "https://arenabh.live/img/facilities/undefined/202310071702551039350.png",
//           "pageUrl": "",
//           "uniqueCode": "padel-in-kuwait"
//       }
//   ],
//   "groups": [
//       {
//           "category": "WA",
//           "categoryLabelEn": "Women A",
//           "categoryLabelAr": "نساء A\n",
//           "groups": [
//               {
//                   "groupNameEn": "Group A",
//                   "groupNameAr": "مجموعة A",
//                   "teams": [
//                       {
//                           "id": "7554",
//                           "name": "51274-51275",
//                           "category": "WA",
//                           "matchesPlayed": "3",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "51274",
//                               "mode": "viewer",
//                               "name": "Iman Mitwaly",
//                               "initials": "IM",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "QJ5wDpX1s2nUH",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51275",
//                               "mode": "viewer",
//                               "name": "Mora",
//                               "initials": "MO",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "nb3kUMsfSc2dB",
//                               "level": 0
//                           }
//                       },
//                       {
//                           "id": "7559",
//                           "name": "51282-51283",
//                           "category": "WA",
//                           "matchesPlayed": "3",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "51282",
//                               "mode": "viewer",
//                               "name": "Mariam AlSadhan",
//                               "initials": "MA",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "iyAUQZgNnSL02",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51283",
//                               "mode": "viewer",
//                               "name": "Dalal AlFares",
//                               "initials": "DA",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "5dz4E3ctQTAHB",
//                               "level": 0
//                           }
//                       },
//                       {
//                           "id": "7557",
//                           "name": "51279-51280",
//                           "category": "WA",
//                           "matchesPlayed": "3",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "51279",
//                               "mode": "viewer",
//                               "name": "Reem AlSharhan",
//                               "initials": "RA",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "67alYebL1TtzK",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51280",
//                               "mode": "viewer",
//                               "name": "Aseel AlKanderi",
//                               "initials": "AA",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "6EITJtrYvB4uO",
//                               "level": 0
//                           }
//                       },
//                       {
//                           "id": "7560",
//                           "name": "50285-51284",
//                           "category": "WA",
//                           "matchesPlayed": "3",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "50285",
//                               "mode": "viewer",
//                               "name": "Dalal Al Qenaei",
//                               "initials": "DQ",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "iCxpIhgAMjPVX",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51284",
//                               "mode": "viewer",
//                               "name": "Jana BinAli",
//                               "initials": "JB",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "iXnN3zgWvpRx1",
//                               "level": 0
//                           }
//                       }
//                   ]
//               },
//               {
//                   "groupNameEn": "Group B",
//                   "groupNameAr": "مجموعة B",
//                   "teams": [
//                       {
//                           "id": "7555",
//                           "name": "50842-51276",
//                           "category": "WA",
//                           "matchesPlayed": "2",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "50842",
//                               "mode": "viewer",
//                               "name": "Mayar Tawfik",
//                               "initials": "MT",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "aHf8j42UXireL",
//                               "level": "8.5"
//                           },
//                           "player2": {
//                               "id": "51276",
//                               "mode": "viewer",
//                               "name": "Noha Amr",
//                               "initials": "NA",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "uzK6ZO1n27lwR",
//                               "level": 0
//                           }
//                       },
//                       {
//                           "id": "7558",
//                           "name": "48588-51281",
//                           "category": "WA",
//                           "matchesPlayed": "2",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "48588",
//                               "mode": "viewer",
//                               "name": "Zainab Sarkhou",
//                               "initials": "ZS",
//                               "picUrl": null,
//                               "rank": "2",
//                               "salt": "4QSRWL78AXYpn",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51281",
//                               "mode": "viewer",
//                               "name": "Sara Behbehani",
//                               "initials": "SB",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "nu4Bp5rKDlOZm",
//                               "level": 0
//                           }
//                       },
//                       {
//                           "id": "7556",
//                           "name": "51277-51278",
//                           "category": "WA",
//                           "matchesPlayed": "2",
//                           "points": "0",
//                           "avgRank": 1,
//                           "avgLevel": 0,
//                           "player1": {
//                               "id": "51277",
//                               "mode": "viewer",
//                               "name": "Mariam Saraj",
//                               "initials": "MS",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "WEs2e7nDoJQC0",
//                               "level": 0
//                           },
//                           "player2": {
//                               "id": "51278",
//                               "mode": "viewer",
//                               "name": "Fatma Janahi",
//                               "initials": "FJ",
//                               "picUrl": null,
//                               "rank": "1",
//                               "salt": "oalsVtd8yxuDK",
//                               "level": 0
//                           }
//                       }
//                   ]
//               }
//           ]
//       }
//   ],
//   "teamsCategories": [
//       {
//           "category": "A",
//           "categoryLabelEn": "Category A",
//           "categoryLabelAr": "تصنيف A",
//           "teams": [
//               {
//                   "id": "7553",
//                   "name": "51271-51272",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51271",
//                       "mode": "viewer",
//                       "name": "Ahmed AlEbrahim",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "fPhpG6kBXexMb",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51272",
//                       "mode": "viewer",
//                       "name": "Abdullah AlMishouti",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "XwIVuL3Ks2xYi",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7538",
//                   "name": "51245-50341",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51245",
//                       "mode": "viewer",
//                       "name": "Aziz Mayouf",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "08mWoyhrJCvFk",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50341",
//                       "mode": "viewer",
//                       "name": "J",
//                       "initials": "J",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "P57zjdDw80qU6",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7539",
//                   "name": "51246-51247",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51246",
//                       "mode": "viewer",
//                       "name": "Ahmed Ashour",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "D3staO4HdhqNG",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51247",
//                       "mode": "viewer",
//                       "name": "Khalifa AlMulla",
//                       "initials": "KA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qhYUa0Tk1eVul",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7540",
//                   "name": "51248-51249",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51248",
//                       "mode": "viewer",
//                       "name": "Ali Hayat",
//                       "initials": "AH",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "OQL3lx9Wp0VmE",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51249",
//                       "mode": "viewer",
//                       "name": "Humood AlJunaidel",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "dyCxDcgv0B6qY",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7541",
//                   "name": "51250-51251",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51250",
//                       "mode": "viewer",
//                       "name": "Mohammed AlTerki",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "8LmHnDz5wCV4K",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51251",
//                       "mode": "viewer",
//                       "name": "Hussain Shams",
//                       "initials": "HS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "1OcqypfmuESgx",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7542",
//                   "name": "51252-51253",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51252",
//                       "mode": "viewer",
//                       "name": "Sherif Makhlouf",
//                       "initials": "SM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "DsCXE6wH3VvT1",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51253",
//                       "mode": "viewer",
//                       "name": "Khaled Nagy",
//                       "initials": "KN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "fhiNoJE0aAXv4",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7543",
//                   "name": "51254-51255",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51254",
//                       "mode": "viewer",
//                       "name": "Abdullah Jawad",
//                       "initials": "AJ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "WpBe3Sir7cXnu",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51255",
//                       "mode": "viewer",
//                       "name": "Dawood Hashem",
//                       "initials": "DH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "prVO1YCwqJ0FN",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7544",
//                   "name": "50364-50175",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50364",
//                       "mode": "viewer",
//                       "name": "A",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "rP59V4Q8xRd6I",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50175",
//                       "mode": "viewer",
//                       "name": "Fluad Bahbahani",
//                       "initials": "FB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "k2f9MGzcLbKWT",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7545",
//                   "name": "51256-51257",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51256",
//                       "mode": "viewer",
//                       "name": "Bader AlSaed",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "H0JI41dvUerbC",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51257",
//                       "mode": "viewer",
//                       "name": "Duaij AlDuaij",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "DreTKzxctV3sX",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7547",
//                   "name": "51260-51261",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51260",
//                       "mode": "viewer",
//                       "name": "Abdullah AlRoudhan",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "lNmp1EMw26yZk",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51261",
//                       "mode": "viewer",
//                       "name": "Abdullah AlSalem",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "9fWGZdmvNspUu",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7548",
//                   "name": "51262-51263",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51262",
//                       "mode": "viewer",
//                       "name": "Khalifa AlKhalifa",
//                       "initials": "KA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "6GTBIQLhokOqY",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51263",
//                       "mode": "viewer",
//                       "name": "Yousef AlMajdely",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "tswkUSAzBrK1T",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7549",
//                   "name": "51264-51265",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51264",
//                       "mode": "viewer",
//                       "name": "Mishaal AlDuaij",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "cLqDOw4s2XtfB",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51265",
//                       "mode": "viewer",
//                       "name": "Hamad Malallah",
//                       "initials": "HM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ywXQGjW7ZlzE5",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7550",
//                   "name": "51266-51267",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51266",
//                       "mode": "viewer",
//                       "name": "Talal Abdullah",
//                       "initials": "TA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "VIJApqHKEwndR",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51267",
//                       "mode": "viewer",
//                       "name": "Yousef Nizar",
//                       "initials": "YN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Q7kjghKt5en0X",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7551",
//                   "name": "51268-51269",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51268",
//                       "mode": "viewer",
//                       "name": "Omar Behrozian",
//                       "initials": "OB",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "mvwuTepHqcy5A",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51269",
//                       "mode": "viewer",
//                       "name": "Abdullah Ahli",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "iHwtIZxqnVs8M",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7552",
//                   "name": "33508-51270",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "33508",
//                       "mode": "viewer",
//                       "name": "Youssef Hossam",
//                       "initials": "YH",
//                       "picUrl": null,
//                       "rank": "3",
//                       "salt": "qiMaGK9cPWJ13",
//                       "level": 9
//                   },
//                   "player2": {
//                       "id": "51270",
//                       "mode": "viewer",
//                       "name": "George Wakim",
//                       "initials": "GW",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "tH29CG7ElLYAm",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7546",
//                   "name": "51258-51259",
//                   "category": "A",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51258",
//                       "mode": "viewer",
//                       "name": "Dhari AlAnsari",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "7LQMjkOrtbZpz",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51259",
//                       "mode": "viewer",
//                       "name": "Abdulmohsen AlAnsari",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "SPxR8TQKj2edo",
//                       "level": 0
//                   }
//               }
//           ]
//       },
//       {
//           "category": "B",
//           "categoryLabelEn": "Category B",
//           "categoryLabelAr": "تصنيف B",
//           "teams": [
//               {
//                   "id": "7298",
//                   "name": "45461-46165",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45461",
//                       "mode": "viewer",
//                       "name": "Hussain Al Mussawi",
//                       "initials": "HM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "5.5"
//                   },
//                   "player2": {
//                       "id": "46165",
//                       "mode": "viewer",
//                       "name": "Mohammad Jawad Almazeedi",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "5.3"
//                   }
//               },
//               {
//                   "id": "7261",
//                   "name": "45202-50750",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45202",
//                       "mode": "viewer",
//                       "name": "Fawaz Almutairi",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 2
//                   },
//                   "player2": {
//                       "id": "50750",
//                       "mode": "viewer",
//                       "name": "Mohammad Alshatti",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Vx0OPLlABrg2s",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "7040",
//                   "name": "45065-47073",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45065",
//                       "mode": "viewer",
//                       "name": "Faisal Al-Olayan",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "3",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "47073",
//                       "mode": "viewer",
//                       "name": "Thunayan Al-ghanim",
//                       "initials": "TA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 6
//                   }
//               },
//               {
//                   "id": "7234",
//                   "name": "44125-50852",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44125",
//                       "mode": "viewer",
//                       "name": "Ahmad Al-Harbi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "50852",
//                       "mode": "viewer",
//                       "name": "Abdullah Hamad",
//                       "initials": "AH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "dYAivBel2JcQN",
//                       "level": "8.5"
//                   }
//               },
//               {
//                   "id": "7230",
//                   "name": "50851-49975",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50851",
//                       "mode": "viewer",
//                       "name": "Hasan Alghareeb",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "nkX58VtsL6PA2",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "49975",
//                       "mode": "viewer",
//                       "name": "Ahmed Khamis",
//                       "initials": "AK",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "FKzpNoav1E6yk",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7222",
//                   "name": "44866-17990",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44866",
//                       "mode": "viewer",
//                       "name": "Dhari Al-Athari",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "2.9"
//                   },
//                   "player2": {
//                       "id": "17990",
//                       "mode": "viewer",
//                       "name": "Anas Alshaiji",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "4",
//                       "salt": "VMxRDve5rzlSu",
//                       "level": 6
//                   }
//               },
//               {
//                   "id": "7210",
//                   "name": "46363-48163",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46363",
//                       "mode": "viewer",
//                       "name": "Mubaraak Alomran",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "6.6"
//                   },
//                   "player2": {
//                       "id": "48163",
//                       "mode": "viewer",
//                       "name": "Yaqoub",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "UsrkhDiI2g6eT",
//                       "level": "4.5"
//                   }
//               },
//               {
//                   "id": "7209",
//                   "name": "44011-44564",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44011",
//                       "mode": "viewer",
//                       "name": "Abdulrahman Altabtabaei",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "44564",
//                       "mode": "viewer",
//                       "name": "Abdulaziz  Altabtabae ",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7055",
//                   "name": "2739-47263",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "2739",
//                       "mode": "viewer",
//                       "name": "Husain Bahbahani",
//                       "initials": "HB",
//                       "picUrl": null,
//                       "rank": "3",
//                       "salt": "04c6457e29c10",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "47263",
//                       "mode": "viewer",
//                       "name": "Yousef Butaiban",
//                       "initials": "YB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "7207",
//                   "name": "50839-48045",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50839",
//                       "mode": "viewer",
//                       "name": "Mahammad Albuloushi",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "n7TzmshE1YM4U",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "48045",
//                       "mode": "viewer",
//                       "name": "Ibrahim Alansari",
//                       "initials": "IA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "uSid6BOxgatqP",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7060",
//                   "name": "47014-45473",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47014",
//                       "mode": "viewer",
//                       "name": "Talal Alhasan",
//                       "initials": "TA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "45473",
//                       "mode": "viewer",
//                       "name": "Hussain Albahrani",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "6.2"
//                   }
//               },
//               {
//                   "id": "7070",
//                   "name": "50779-50780",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50779",
//                       "mode": "viewer",
//                       "name": "Hashem Abul",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "DLp8kJzW7FCaO",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50780",
//                       "mode": "viewer",
//                       "name": "Yaqoup Al Fadri",
//                       "initials": "YF",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "dgxYDfp16bPz4",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7083",
//                   "name": "47341-48190",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47341",
//                       "mode": "viewer",
//                       "name": "Yousef Alshatte",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "5.5"
//                   },
//                   "player2": {
//                       "id": "48190",
//                       "mode": "viewer",
//                       "name": "Mohammad Alsenan",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "nyi0CQAGuUzwL",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7206",
//                   "name": "45097-30200",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45097",
//                       "mode": "viewer",
//                       "name": "Faisal Bouqrais",
//                       "initials": "FB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "30200",
//                       "mode": "viewer",
//                       "name": "Naser Al Obaidly",
//                       "initials": "NO",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ10",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7012",
//                   "name": "47252-18000",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47252",
//                       "mode": "viewer",
//                       "name": "YOUSEF ALTEMEEMI",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 9
//                   },
//                   "player2": {
//                       "id": "18000",
//                       "mode": "viewer",
//                       "name": "Abdulaziz alqaseer",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "4",
//                       "salt": "0nwTm9iEoXHue",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7099",
//                   "name": "44680-47243",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44680",
//                       "mode": "viewer",
//                       "name": "Bader Al-Bedah",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "47243",
//                       "mode": "viewer",
//                       "name": "yousef alsaqer",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7165",
//                   "name": "43548-43735",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43548",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Alotaibi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "43735",
//                       "mode": "viewer",
//                       "name": "Abdullah Alhazzaa",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "6.1"
//                   }
//               },
//               {
//                   "id": "7460",
//                   "name": "50744-51104",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50744",
//                       "mode": "viewer",
//                       "name": "Ali Mounir",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "3ADd5ofxBly9b",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "51104",
//                       "mode": "viewer",
//                       "name": "Omar Zaher",
//                       "initials": "OZ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "orPDLfxXylV4C",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7461",
//                   "name": "51105-51106",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51105",
//                       "mode": "viewer",
//                       "name": "Nasser Borashed",
//                       "initials": "NB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "CXe29QqxwJLG1",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51106",
//                       "mode": "viewer",
//                       "name": "Hadi Sabbah",
//                       "initials": "HS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Z2AgTaIUSREkD",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7531",
//                   "name": "51218-51219",
//                   "category": "B",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51218",
//                       "mode": "viewer",
//                       "name": "Faisal Bouqrais",
//                       "initials": "FB",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "ktevPj28lfpuo",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51219",
//                       "mode": "viewer",
//                       "name": "Nasser AlObaidly",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "17HO6MNmgYboh",
//                       "level": 0
//                   }
//               }
//           ]
//       },
//       {
//           "category": "C",
//           "categoryLabelEn": "Category C",
//           "categoryLabelAr": "تصنيف C",
//           "teams": [
//               {
//                   "id": "7192",
//                   "name": "50829-50830",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50829",
//                       "mode": "viewer",
//                       "name": "Khaled Al Satalam",
//                       "initials": "KS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "fi9h1rsScxpGR",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50830",
//                       "mode": "viewer",
//                       "name": "Mohammed Al Shuaibi",
//                       "initials": "MS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "IxCTofWXYE4d8",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7189",
//                   "name": "50827-50828",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50827",
//                       "mode": "viewer",
//                       "name": "Ahmed Al Qabandi",
//                       "initials": "AQ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "NBFLZhbcSDQTf",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50828",
//                       "mode": "viewer",
//                       "name": "Essa Al Abdullah",
//                       "initials": "EA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "6kAUSXJo1tVK5",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7179",
//                   "name": "50821-50822",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50821",
//                       "mode": "viewer",
//                       "name": "Ahmad Mandani",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "lOkV73Ga6f5h2",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50822",
//                       "mode": "viewer",
//                       "name": "Ibrahim Al Hassan",
//                       "initials": "IH",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "M0Yvg7sQur3be",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7177",
//                   "name": "50815-47183",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50815",
//                       "mode": "viewer",
//                       "name": "Ahmad",
//                       "initials": "AH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "yLM0kphCH1S67",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "47183",
//                       "mode": "viewer",
//                       "name": "Yousef Al Wazzan",
//                       "initials": "YW",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7173",
//                   "name": "50818-50818",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46503",
//                       "mode": "viewer",
//                       "name": "Nawaf AlJamaan",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50818",
//                       "mode": "viewer",
//                       "name": "Ghanim Al Ghanim",
//                       "initials": "GG",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "bAlIXmpW8F145",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7141",
//                   "name": "50806-50807",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50806",
//                       "mode": "viewer",
//                       "name": "Yahya Al Mazyed",
//                       "initials": "YM",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "kVY62jCo9wK13",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50825",
//                       "mode": "viewer",
//                       "name": "Fahed Al Dossari",
//                       "initials": "FD",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "Cd754NoFG3PAn",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7164",
//                   "name": "43866-45018",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43866",
//                       "mode": "viewer",
//                       "name": "ABDULLAH M ALRAMMAH",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "45018",
//                       "mode": "viewer",
//                       "name": "Fahad Bader",
//                       "initials": "FB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "5.5"
//                   }
//               },
//               {
//                   "id": "7158",
//                   "name": "46061-48358",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46061",
//                       "mode": "viewer",
//                       "name": "Mohammad Alayoub",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "22456",
//                       "mode": "viewer",
//                       "name": "Ali Al Sabah",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ02",
//                       "level": "4.7"
//                   }
//               },
//               {
//                   "id": "6776",
//                   "name": "17994-17995",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "17994",
//                       "mode": "viewer",
//                       "name": "Abdulrahman  Alkhulaifi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "SVtnHoARN85Yr",
//                       "level": "4.5"
//                   },
//                   "player2": {
//                       "id": "17995",
//                       "mode": "viewer",
//                       "name": "Saud Alobaidan",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "6",
//                       "salt": "ZMxS4hItN0PsC",
//                       "level": "5.5"
//                   }
//               },
//               {
//                   "id": "7193",
//                   "name": "46765-50831",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46765",
//                       "mode": "viewer",
//                       "name": "Saad Almutairi",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "4.4"
//                   },
//                   "player2": {
//                       "id": "45943",
//                       "mode": "viewer",
//                       "name": "misahal aa",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "6.4"
//                   }
//               },
//               {
//                   "id": "7197",
//                   "name": "46368-48191",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46368",
//                       "mode": "viewer",
//                       "name": "mubarak alkhuzam",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "3.5"
//                   },
//                   "player2": {
//                       "id": "48191",
//                       "mode": "viewer",
//                       "name": "abdulaziz tifoni",
//                       "initials": "AT",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "BWfLnHwkrbYUZ",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7420",
//                   "name": "50326-50327",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50326",
//                       "mode": "viewer",
//                       "name": "Aly Khashaba",
//                       "initials": "AK",
//                       "picUrl": "https://arenabh.live/img/users/50326/202312120010245082970.png",
//                       "rank": "2",
//                       "salt": "lSdvxc4fTYBDg",
//                       "level": 5
//                   },
//                   "player2": {
//                       "id": "50327",
//                       "mode": "viewer",
//                       "name": "Omar Khalifa",
//                       "initials": "OK",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "uzPMGimVZH2Qb",
//                       "level": 3
//                   }
//               },
//               {
//                   "id": "7421",
//                   "name": "48594-46759",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48594",
//                       "mode": "viewer",
//                       "name": "Abdulrahman AlShaibani",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "wpMaGWIvTRekg",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "46759",
//                       "mode": "viewer",
//                       "name": "Saad Alq",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "6.5"
//                   }
//               },
//               {
//                   "id": "7422",
//                   "name": "46904-46145",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46904",
//                       "mode": "viewer",
//                       "name": "Sayed Almousawi",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 5
//                   },
//                   "player2": {
//                       "id": "51208",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Shehab",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Pyg36A0iWJm2n",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7423",
//                   "name": "43773-47146",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43773",
//                       "mode": "viewer",
//                       "name": "Abdullah Almutawa",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 4
//                   },
//                   "player2": {
//                       "id": "47146",
//                       "mode": "viewer",
//                       "name": "yaser maqseed",
//                       "initials": "YM",
//                       "picUrl": "https://arenabh.live/img/users/47146/202312130940116191470.png",
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "3.5"
//                   }
//               },
//               {
//                   "id": "7424",
//                   "name": "51066-44505",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51066",
//                       "mode": "viewer",
//                       "name": "Salman Behbehani",
//                       "initials": "SB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "1HTmuFNRapSG3",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "44505",
//                       "mode": "viewer",
//                       "name": "Ali Saeed",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "3.3"
//                   }
//               },
//               {
//                   "id": "7425",
//                   "name": "45724-44285",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45724",
//                       "mode": "viewer",
//                       "name": "Khaled Nuseibeh",
//                       "initials": "KN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "6.2"
//                   },
//                   "player2": {
//                       "id": "44285",
//                       "mode": "viewer",
//                       "name": "Ahmed Alkanderi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7426",
//                   "name": "43726-46046",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43726",
//                       "mode": "viewer",
//                       "name": "Abdullah Alhaddad",
//                       "initials": "AA",
//                       "picUrl": "https://arenabh.live/img/users/43726/202312110833125626190.png",
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 4
//                   },
//                   "player2": {
//                       "id": "46046",
//                       "mode": "viewer",
//                       "name": "Mohammad Al-Abdullah",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "2.5"
//                   }
//               },
//               {
//                   "id": "7427",
//                   "name": "51028-51028",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51028",
//                       "mode": "viewer",
//                       "name": "Rakan AlQenai",
//                       "initials": "RA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "lixuqRgd7HphV",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51028",
//                       "mode": "viewer",
//                       "name": "Rakan AlQenai",
//                       "initials": "RA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "lixuqRgd7HphV",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7428",
//                   "name": "45913-46013",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45913",
//                       "mode": "viewer",
//                       "name": "Meshari",
//                       "initials": "ME",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "46013",
//                       "mode": "viewer",
//                       "name": "Mohammad",
//                       "initials": "MO",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7429",
//                   "name": "48023-46147",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48023",
//                       "mode": "viewer",
//                       "name": "Abdullah bloushi",
//                       "initials": "AB",
//                       "picUrl": "https://arenabh.live/img/users/48023/202311060957256581910.png",
//                       "rank": "1",
//                       "salt": "NYGk3RgdJI8PZ",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "46147",
//                       "mode": "viewer",
//                       "name": "Mohammad Buarki",
//                       "initials": "MB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "6784",
//                   "name": "45201-45514",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45201",
//                       "mode": "viewer",
//                       "name": "Fawaz Aswad",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "45514",
//                       "mode": "viewer",
//                       "name": "hussain karam",
//                       "initials": "HK",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 5
//                   }
//               },
//               {
//                   "id": "7038",
//                   "name": "50761-50762",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50761",
//                       "mode": "viewer",
//                       "name": "Abdulrahman Al Awadhi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "pvrB9dHltwQeb",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50762",
//                       "mode": "viewer",
//                       "name": "Ali Al Janaie",
//                       "initials": "AJ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "eankmi3Uxuf65",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7027",
//                   "name": "50756-50757",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50756",
//                       "mode": "viewer",
//                       "name": "Ahmed Yateem",
//                       "initials": "AY",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "2Un4ATXfNWRIz",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50757",
//                       "mode": "viewer",
//                       "name": "Fahad Al Asfoor",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "k4ozqjMJvyLnT",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7026",
//                   "name": "48160-48998",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48160",
//                       "mode": "viewer",
//                       "name": "Osama Alkhadher",
//                       "initials": "OA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Bc40Ltib8Opnl",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "48998",
//                       "mode": "viewer",
//                       "name": "Omar Aladwani",
//                       "initials": "OA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "mrIsVLNq6GMEK",
//                       "level": 4
//                   }
//               },
//               {
//                   "id": "7024",
//                   "name": "50754-50755",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50754",
//                       "mode": "viewer",
//                       "name": "Yousef  Al Qaloshi",
//                       "initials": "YQ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "JlNI1DM2cn67A",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50755",
//                       "mode": "viewer",
//                       "name": "Rashed Al Rashed",
//                       "initials": "RR",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "DyveORBXI6iqa",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7021",
//                   "name": "50751-50752",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50751",
//                       "mode": "viewer",
//                       "name": "Ali Al Sarraf",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "1dhrBVx4n60Iw",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50752",
//                       "mode": "viewer",
//                       "name": "Abdullatif Al Roudhan",
//                       "initials": "AR",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "aLwM87Vyv3PUJ",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7016",
//                   "name": "46194-48152",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46194",
//                       "mode": "viewer",
//                       "name": "Mohammed",
//                       "initials": "MO",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "43889",
//                       "mode": "viewer",
//                       "name": "Abdullah Turki",
//                       "initials": "AT",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "6.4"
//                   }
//               },
//               {
//                   "id": "7015",
//                   "name": "50747-50748",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50747",
//                       "mode": "viewer",
//                       "name": "Ahmed Al salal",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "BgThVKY4C3DwJ",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50748",
//                       "mode": "viewer",
//                       "name": "Yaqoup Alyousfi",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "H9IKShqyVz7eO",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7010",
//                   "name": "45424-47220",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45424",
//                       "mode": "viewer",
//                       "name": "Humood Alrubayea",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "4.5"
//                   },
//                   "player2": {
//                       "id": "47220",
//                       "mode": "viewer",
//                       "name": "Yousef Alkhudher",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "3.4"
//                   }
//               },
//               {
//                   "id": "7002",
//                   "name": "18005-44543",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "18005",
//                       "mode": "viewer",
//                       "name": "Eissa  Ashkanani",
//                       "initials": "EA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ZTE3Sm4D6VdRK",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "45998",
//                       "mode": "viewer",
//                       "name": "Mohamed Alsharqawi",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "6995",
//                   "name": "47499-50727",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47499",
//                       "mode": "viewer",
//                       "name": "Abdullah AlAwadhi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "20VMFTiHv6I17",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "50727",
//                       "mode": "viewer",
//                       "name": "Mohammed Algharabally",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "k09Bt7xlj8rPu",
//                       "level": "6.5"
//                   }
//               },
//               {
//                   "id": "6990",
//                   "name": "44858-46863",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44858",
//                       "mode": "viewer",
//                       "name": "Dhafer- Bu Mubark",
//                       "initials": "DM",
//                       "picUrl": "https://arenabh.live/img/users/44858/202311091310209896580.png",
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "5.7"
//                   },
//                   "player2": {
//                       "id": "46863",
//                       "mode": "viewer",
//                       "name": "Saoud Aljassem",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "6771",
//                   "name": "44669-50629",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44669",
//                       "mode": "viewer",
//                       "name": "Bader Alayoub",
//                       "initials": "BA",
//                       "picUrl": "https://arenabh.live/img/users/44669/202310271819364665260.png",
//                       "rank": "3",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "5.5"
//                   },
//                   "player2": {
//                       "id": "50629",
//                       "mode": "viewer",
//                       "name": "Daniel",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "XVIHjuG8y7sSJ",
//                       "level": 7
//                   }
//               },
//               {
//                   "id": "6781",
//                   "name": "46283-45260",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46283",
//                       "mode": "viewer",
//                       "name": "Mohammed Alrsheed",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "2.9"
//                   },
//                   "player2": {
//                       "id": "45260",
//                       "mode": "viewer",
//                       "name": "Hamad Al Kandari",
//                       "initials": "HK",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "6.5"
//                   }
//               },
//               {
//                   "id": "7133",
//                   "name": "48792-17997",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48792",
//                       "mode": "viewer",
//                       "name": "ALi  Mosawi",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "EPRGIF8T6WcJ3",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "17997",
//                       "mode": "viewer",
//                       "name": "Mohammed Alsawwahah",
//                       "initials": "MA",
//                       "picUrl": "https://arenabh.live/img/users/17997/202312050735594115870.png",
//                       "rank": "1",
//                       "salt": "CExJ0jOiyq8cI",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "6786",
//                   "name": "44495-43808",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44495",
//                       "mode": "viewer",
//                       "name": "Ali Mubarak",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "3.6"
//                   },
//                   "player2": {
//                       "id": "43808",
//                       "mode": "viewer",
//                       "name": "Abdullah Alshatti",
//                       "initials": "AA",
//                       "picUrl": "https://arenabh.live/img/users/43808/202312091342159972350.png",
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "4.9"
//                   }
//               },
//               {
//                   "id": "6984",
//                   "name": "44842-47265",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44842",
//                       "mode": "viewer",
//                       "name": "Dhari Alshammari",
//                       "initials": "DA",
//                       "picUrl": "https://arenabh.live/img/users/44842/202312041854344555210.png",
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "46436",
//                       "mode": "viewer",
//                       "name": "Naser Alfaraj",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 3
//                   }
//               },
//               {
//                   "id": "6983",
//                   "name": "48003-43876",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48003",
//                       "mode": "viewer",
//                       "name": "Bader Almosswi",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "GyUbADgu8rlnW",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "43876",
//                       "mode": "viewer",
//                       "name": "abdullah naser",
//                       "initials": "AN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "6982",
//                   "name": "43921-46254",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43921",
//                       "mode": "viewer",
//                       "name": "Abdulmohsen Alhashem",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 4
//                   },
//                   "player2": {
//                       "id": "46254",
//                       "mode": "viewer",
//                       "name": "Mohammed Alhusayan",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "2.9"
//                   }
//               },
//               {
//                   "id": "6794",
//                   "name": "2729-17934",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "2729",
//                       "mode": "viewer",
//                       "name": "Ahmed  Ashknani",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "3",
//                       "salt": "69dcbe9469cac",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "17934",
//                       "mode": "viewer",
//                       "name": "mohammad alkandari",
//                       "initials": "MA",
//                       "picUrl": "https://arenabh.live/img/users/17934/202312150939434621520.png",
//                       "rank": "7",
//                       "salt": "9PsHcN5wV8f1E",
//                       "level": 7
//                   }
//               },
//               {
//                   "id": "6903",
//                   "name": "44956-44616",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44956",
//                       "mode": "viewer",
//                       "name": "Fahad Al Hasawi",
//                       "initials": "FH",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "44616",
//                       "mode": "viewer",
//                       "name": "Aziz Alawadhy",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "6.4"
//                   }
//               },
//               {
//                   "id": "6901",
//                   "name": "20221-44747",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "20221",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Alhamadi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ00",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "44747",
//                       "mode": "viewer",
//                       "name": "Badr Abduljalil",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "4.4"
//                   }
//               },
//               {
//                   "id": "6795",
//                   "name": "50723-50726",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50723",
//                       "mode": "viewer",
//                       "name": "Ahmad",
//                       "initials": "AH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "oRzsmuO43GQFM",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "50726",
//                       "mode": "viewer",
//                       "name": "Tarek",
//                       "initials": "TA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "7QcJ4FaqYZTpM",
//                       "level": "6.5"
//                   }
//               },
//               {
//                   "id": "6876",
//                   "name": "4787-33729",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "4787",
//                       "mode": "viewer",
//                       "name": "Aziz",
//                       "initials": "AZ",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "0yYOndApBVGK5",
//                       "level": "4.5"
//                   },
//                   "player2": {
//                       "id": "33729",
//                       "mode": "viewer",
//                       "name": "Mubarak Safaih",
//                       "initials": "MS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGK9cPWJ13",
//                       "level": "5.8"
//                   }
//               },
//               {
//                   "id": "6873",
//                   "name": "29392-32328",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "29392",
//                       "mode": "viewer",
//                       "name": "Mohammed Almazeedi",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGK9cPWJ09",
//                       "level": "5.1"
//                   },
//                   "player2": {
//                       "id": "32328",
//                       "mode": "viewer",
//                       "name": "SAYED HAMZA ALMAZEEDI",
//                       "initials": "SA",
//                       "picUrl": "https://arenabh.live/img/users/32328/202312132121557292960.png",
//                       "rank": "2",
//                       "salt": "qiMaGK9cPWJ12",
//                       "level": 2
//                   }
//               },
//               {
//                   "id": "6857",
//                   "name": "46775-43595",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46775",
//                       "mode": "viewer",
//                       "name": "Sadeq Abul",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "6.6"
//                   },
//                   "player2": {
//                       "id": "43595",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Safar",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "3.2"
//                   }
//               },
//               {
//                   "id": "6823",
//                   "name": "31981-44467",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "31981",
//                       "mode": "viewer",
//                       "name": "Salman Almazeedi",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ12",
//                       "level": "5.5"
//                   },
//                   "player2": {
//                       "id": "44467",
//                       "mode": "viewer",
//                       "name": "Ali Haji",
//                       "initials": "AH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "6.6"
//                   }
//               },
//               {
//                   "id": "7096",
//                   "name": "50787-17834",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50787",
//                       "mode": "viewer",
//                       "name": "mohammad alhamoud",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "We7zZbGxNK8Rh",
//                       "level": "5.5"
//                   },
//                   "player2": {
//                       "id": "17834",
//                       "mode": "viewer",
//                       "name": "mohamm",
//                       "initials": "MO",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "6vpiB2RGsejoP",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7092",
//                   "name": "50788-50789",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50788",
//                       "mode": "viewer",
//                       "name": "Ismael Al Youha",
//                       "initials": "IY",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "eIScgJv25Y1fi",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50789",
//                       "mode": "viewer",
//                       "name": "Fahed Al Khashti",
//                       "initials": "FK",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ktcAZPTfv7RpY",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7059",
//                   "name": "50775-50776",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50775",
//                       "mode": "viewer",
//                       "name": "Khaled Al Mullla",
//                       "initials": "KM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "SjxfBuCU8iGXQ",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "47858",
//                       "mode": "viewer",
//                       "name": "abdulaziz alabdulhadi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "AExkF86ls9BpO",
//                       "level": 7
//                   }
//               },
//               {
//                   "id": "7094",
//                   "name": "18160-18161",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "18160",
//                       "mode": "viewer",
//                       "name": "Saad J",
//                       "initials": "SJ",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "VNpfvkuRI8sCt",
//                       "level": 5
//                   },
//                   "player2": {
//                       "id": "18161",
//                       "mode": "viewer",
//                       "name": "Abdulrahman ALOMAR",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "gLkw91XUVJCDv",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7054",
//                   "name": "50772-50773",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "49711",
//                       "mode": "viewer",
//                       "name": "Abdullah",
//                       "initials": "AB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "TZlhYw4spIvPQ",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50773",
//                       "mode": "viewer",
//                       "name": "Basil Al Eanzi",
//                       "initials": "BE",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "IoGnArW5fLXEQ",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7053",
//                   "name": "45658-46756",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45658",
//                       "mode": "viewer",
//                       "name": "Khaled Al Zayed",
//                       "initials": "KZ",
//                       "picUrl": "https://arenabh.live/img/users/45658/202311031245124520770.png",
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "46756",
//                       "mode": "viewer",
//                       "name": "SAAD ALMANEE",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": "8.5"
//                   }
//               },
//               {
//                   "id": "7050",
//                   "name": "43515-25038",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43515",
//                       "mode": "viewer",
//                       "name": "Abdulaziz AlGhais",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "25038",
//                       "mode": "viewer",
//                       "name": "Ghanim Al-Burshid",
//                       "initials": "GA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ05",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "7047",
//                   "name": "32725-50765",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "32725",
//                       "mode": "viewer",
//                       "name": "Suliman Alabdulla",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGK9cPWJ12",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "50765",
//                       "mode": "viewer",
//                       "name": "Ibrahim Al Kaabi",
//                       "initials": "IK",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "WEyCfZ5qB6JNk",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7103",
//                   "name": "46053-44571",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46053",
//                       "mode": "viewer",
//                       "name": "Mohammad Alali",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "4.3"
//                   },
//                   "player2": {
//                       "id": "44571",
//                       "mode": "viewer",
//                       "name": "Aqeel Alhaddad",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "3.5"
//                   }
//               },
//               {
//                   "id": "7113",
//                   "name": "45310-48171",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45310",
//                       "mode": "viewer",
//                       "name": "Hamad Aloufan",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "48171",
//                       "mode": "viewer",
//                       "name": "Samhan  Alsamhan",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "sqAZQRObH6ltU",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7117",
//                   "name": "50793-50794",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50793",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Ali",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Tp8wNikmaL1gH",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50794",
//                       "mode": "viewer",
//                       "name": "Adulwahab Al Ali",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "3xFoiwVBcPT9m",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7122",
//                   "name": "43568-44377",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43568",
//                       "mode": "viewer",
//                       "name": "Abdulaziz AlSuraye",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "6.1"
//                   },
//                   "player2": {
//                       "id": "44377",
//                       "mode": "viewer",
//                       "name": "Ali Al Sabah",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "4.4"
//                   }
//               },
//               {
//                   "id": "7125",
//                   "name": "50795-50796",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50795",
//                       "mode": "viewer",
//                       "name": "Hameed Allanqawii",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ln0vp4x5SOKWb",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50796",
//                       "mode": "viewer",
//                       "name": "Ahmed Tariq",
//                       "initials": "AT",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "IWCSnL1Nvxfkz",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7129",
//                   "name": "50797-50798",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50797",
//                       "mode": "viewer",
//                       "name": "Abdullah Al Sadhan",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "mk2pNDj0yIXVG",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50798",
//                       "mode": "viewer",
//                       "name": "Yousif Al Sumait",
//                       "initials": "YS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "v5AqTt7OYCpBa",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7135",
//                   "name": "50802-50803",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50802",
//                       "mode": "viewer",
//                       "name": "Abdullah Al Nasser",
//                       "initials": "AN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "pGjKrsYu9g6zH",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "44762",
//                       "mode": "viewer",
//                       "name": "Barrak",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7130",
//                   "name": "50799-50800",
//                   "category": "C",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47286",
//                       "mode": "viewer",
//                       "name": "Yousif Alduaij",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "50837",
//                       "mode": "viewer",
//                       "name": "Mohammed bastaki",
//                       "initials": "MB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "QmlaX8WzF37ek",
//                       "level": 0
//                   }
//               }
//           ]
//       },
//       {
//           "category": "U12",
//           "categoryLabelEn": "Juniors U12 ",
//           "categoryLabelAr": "Juniors U12 ",
//           "teams": [
//               {
//                   "id": "7569",
//                   "name": "18434-51310",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "18434",
//                       "mode": "viewer",
//                       "name": "Ibrahim Ali",
//                       "initials": "IA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "jyCfIRcwkLp5m",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "51310",
//                       "mode": "viewer",
//                       "name": "Raes AlAbdulbaqi",
//                       "initials": "RA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "jAeq4QukgbTow",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7523",
//                   "name": "51195-51196",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51195",
//                       "mode": "viewer",
//                       "name": "Hamad Alibrahim",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "Cmpq69aTgIQd0",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51196",
//                       "mode": "viewer",
//                       "name": "Abdulrahman Alslaiman",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "r8o0LNSgQB4ci",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7574",
//                   "name": "51316-48584",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51316",
//                       "mode": "viewer",
//                       "name": "Hussain Marafi",
//                       "initials": "HM",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "A9cpqwMLfHF7y",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "48584",
//                       "mode": "viewer",
//                       "name": "Abdulrahman AlSaqoubi ",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "pwWoSgl8GbRMj",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7562",
//                   "name": "51288-51289",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51288",
//                       "mode": "viewer",
//                       "name": "Ali Alebrahim",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "dMxS5CKY2VWbU",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51289",
//                       "mode": "viewer",
//                       "name": "Yahya Al Harazi",
//                       "initials": "YH",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "y9G3cF0m6iKnr",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7039",
//                   "name": "44045-44521",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44045",
//                       "mode": "viewer",
//                       "name": "Abdulwahab Al Salahi",
//                       "initials": "AS",
//                       "picUrl": "https://arenabh.live/img/users/44045/202311251141228937040.png",
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "44521",
//                       "mode": "viewer",
//                       "name": "Abdullah albosaili",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7568",
//                   "name": "51195-51196",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51195",
//                       "mode": "viewer",
//                       "name": "Hamad Alibrahim",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "Cmpq69aTgIQd0",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51196",
//                       "mode": "viewer",
//                       "name": "Abdulrahman Alslaiman",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "r8o0LNSgQB4ci",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7567",
//                   "name": "51308-51309",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51308",
//                       "mode": "viewer",
//                       "name": "Hamed AlSaif",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "qyAsjE5Qa7LtH",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51309",
//                       "mode": "viewer",
//                       "name": "Fahad AlSultan",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "wkYORpgqG9M1s",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7566",
//                   "name": "51306-51307",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51306",
//                       "mode": "viewer",
//                       "name": "Mohammed AlShatti",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "iJfde3hEq1NYj",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51307",
//                       "mode": "viewer",
//                       "name": "Abdullah AlDuwaisan",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "joBNzxOCeEsPv",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7565",
//                   "name": "51304-51305",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51304",
//                       "mode": "viewer",
//                       "name": "Majed AlHouti",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "qNBT9F7vYxQMt",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51305",
//                       "mode": "viewer",
//                       "name": "Ahmed AlRadwan",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "G01EqV5QTw2rx",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7570",
//                   "name": "51290-51291",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51290",
//                       "mode": "viewer",
//                       "name": "Abdullah Matbaqi",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "mIQ5pc79CYEPU",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51291",
//                       "mode": "viewer",
//                       "name": "Hussain Ridan",
//                       "initials": "HR",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "7TBkV9jfiFNsE",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7252",
//                   "name": "50220-50219",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50220",
//                       "mode": "viewer",
//                       "name": "Adel Alfulaij",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "hvjb6rZLTPAk3",
//                       "level": 5
//                   },
//                   "player2": {
//                       "id": "50219",
//                       "mode": "viewer",
//                       "name": "Mubarak Alsabah",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "0hj5oJbwFEPOD",
//                       "level": "4.5"
//                   }
//               },
//               {
//                   "id": "7251",
//                   "name": "50862-50863",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50864",
//                       "mode": "viewer",
//                       "name": "Barrak Al Ajeel",
//                       "initials": "BA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "wGSj3C2iHQDvO",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50863",
//                       "mode": "viewer",
//                       "name": " ALI ALSHATTI",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "qr9E1alCOZsD7",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7571",
//                   "name": "47589-51053",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "47589",
//                       "mode": "viewer",
//                       "name": "Ali Almalik",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "wT68E3DdCtOLS",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "51053",
//                       "mode": "viewer",
//                       "name": "Ali",
//                       "initials": "AL",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "GkLctvozS1hmr",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7564",
//                   "name": "51303-48776",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51303",
//                       "mode": "viewer",
//                       "name": "Nasser AlRoudhan",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "3hKidP7E4vNQI",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "48776",
//                       "mode": "viewer",
//                       "name": "Abdulaziz AlAtwan",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "Y6ua9tOnmyrkL",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7563",
//                   "name": "51290-51291",
//                   "category": "U12",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51290",
//                       "mode": "viewer",
//                       "name": "Abdullah Matbaqi",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "mIQ5pc79CYEPU",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51292",
//                       "mode": "viewer",
//                       "name": "Hussain Eidan",
//                       "initials": "HE",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "h4guoRVSIAYJB",
//                       "level": 0
//                   }
//               }
//           ]
//       },
//       {
//           "category": "U16",
//           "categoryLabelEn": "Juniors U16",
//           "categoryLabelAr": "Juniors U16",
//           "teams": [
//               {
//                   "id": "7575",
//                   "name": "51317-51318",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51317",
//                       "mode": "viewer",
//                       "name": "Bader Naser",
//                       "initials": "BN",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "xYqsojcDCu0Qw",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51318",
//                       "mode": "viewer",
//                       "name": "Ali Mayouf",
//                       "initials": "AM",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "xv7NtZUIa0Ymb",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7572",
//                   "name": "49088-50081",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "49088",
//                       "mode": "viewer",
//                       "name": "نواف القاضي",
//                       "initials": "نا",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "YmwsUXtqh1Qly",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50081",
//                       "mode": "viewer",
//                       "name": "Hashem Almazeedi",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "PIoA2rp58WHGc",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7573",
//                   "name": "51313-51314",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51313",
//                       "mode": "viewer",
//                       "name": "Abdulaziz AlWohaib",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "q3RUG9QIFtl5s",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51314",
//                       "mode": "viewer",
//                       "name": "Fahad AlSaqoubi",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "kgriQ95Vv6N3X",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7561",
//                   "name": "51286-51287",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51286",
//                       "mode": "viewer",
//                       "name": "Abdulwahab Al Rashdan",
//                       "initials": "AR",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Aj4zOfcKakr5U",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51287",
//                       "mode": "viewer",
//                       "name": "Faisal Al Rashdan",
//                       "initials": "FR",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ACtROM9ZNnpds",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7691",
//                   "name": "51407-51408",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51407",
//                       "mode": "viewer",
//                       "name": "Abdulaziz AlBahou",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "clbEQ7L1wNn2M",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51408",
//                       "mode": "viewer",
//                       "name": "Yousef AlHaji",
//                       "initials": "YA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ImSL6xUrahq4O",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "6967",
//                   "name": "43437-48325",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "43437",
//                       "mode": "viewer",
//                       "name": "Abdullah Al-Asousi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": 5
//                   },
//                   "player2": {
//                       "id": "48325",
//                       "mode": "viewer",
//                       "name": "Abdulaziz Al-Asousi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "sJ25FPwapX96t",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7162",
//                   "name": "48238-45633",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48238",
//                       "mode": "viewer",
//                       "name": "Sulaiman Qabazard",
//                       "initials": "SQ",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "mZdPyIa8oUSQh",
//                       "level": 6
//                   },
//                   "player2": {
//                       "id": "45633",
//                       "mode": "viewer",
//                       "name": "Khaled",
//                       "initials": "KH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 6
//                   }
//               },
//               {
//                   "id": "7204",
//                   "name": "48301-48302",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48301",
//                       "mode": "viewer",
//                       "name": "francisco martinez",
//                       "initials": "FM",
//                       "picUrl": "https://arenabh.live/img/users/48301/202312082154323789670.png",
//                       "rank": "1",
//                       "salt": "XfUbEQZ0GBvlo",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "48302",
//                       "mode": "viewer",
//                       "name": "saad alzayed",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "vJFZ2PSMy45xb",
//                       "level": "6.5"
//                   }
//               },
//               {
//                   "id": "7411",
//                   "name": "22682-51053",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "22682",
//                       "mode": "viewer",
//                       "name": "Ali Ebrahim Almalik",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGK9cPWJ02",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "47589",
//                       "mode": "viewer",
//                       "name": "Ali Almalik",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "wT68E3DdCtOLS",
//                       "level": "8.5"
//                   }
//               },
//               {
//                   "id": "7028",
//                   "name": "45828-46208",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45828",
//                       "mode": "viewer",
//                       "name": "Mahdi Sabah",
//                       "initials": "MS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 8
//                   },
//                   "player2": {
//                       "id": "46208",
//                       "mode": "viewer",
//                       "name": "Mohammed Al Furaih",
//                       "initials": "MF",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "8.5"
//                   }
//               },
//               {
//                   "id": "6986",
//                   "name": "44119-48575",
//                   "category": "U16",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44119",
//                       "mode": "viewer",
//                       "name": "Ahmad  Al Sabah ",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGn9cPWK00",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "48575",
//                       "mode": "viewer",
//                       "name": "Bader Sabah",
//                       "initials": "BS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "ZHRlseOT7kDS9",
//                       "level": 6
//                   }
//               }
//           ]
//       },
//       {
//           "category": "WA",
//           "categoryLabelEn": "Women A",
//           "categoryLabelAr": "نساء A\n",
//           "teams": [
//               {
//                   "id": "7555",
//                   "name": "50842-51276",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50842",
//                       "mode": "viewer",
//                       "name": "Mayar Tawfik",
//                       "initials": "MT",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "aHf8j42UXireL",
//                       "level": "8.5"
//                   },
//                   "player2": {
//                       "id": "51276",
//                       "mode": "viewer",
//                       "name": "Noha Amr",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "uzK6ZO1n27lwR",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7556",
//                   "name": "51277-51278",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51277",
//                       "mode": "viewer",
//                       "name": "Mariam Saraj",
//                       "initials": "MS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "WEs2e7nDoJQC0",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51278",
//                       "mode": "viewer",
//                       "name": "Fatma Janahi",
//                       "initials": "FJ",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "oalsVtd8yxuDK",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7557",
//                   "name": "51279-51280",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51279",
//                       "mode": "viewer",
//                       "name": "Reem AlSharhan",
//                       "initials": "RA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "67alYebL1TtzK",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51280",
//                       "mode": "viewer",
//                       "name": "Aseel AlKanderi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "6EITJtrYvB4uO",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7558",
//                   "name": "48588-51281",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48588",
//                       "mode": "viewer",
//                       "name": "Zainab Sarkhou",
//                       "initials": "ZS",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "4QSRWL78AXYpn",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51281",
//                       "mode": "viewer",
//                       "name": "Sara Behbehani",
//                       "initials": "SB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "nu4Bp5rKDlOZm",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7559",
//                   "name": "51282-51283",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51282",
//                       "mode": "viewer",
//                       "name": "Mariam AlSadhan",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "iyAUQZgNnSL02",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51283",
//                       "mode": "viewer",
//                       "name": "Dalal AlFares",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "5dz4E3ctQTAHB",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7560",
//                   "name": "50285-51284",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50285",
//                       "mode": "viewer",
//                       "name": "Dalal Al Qenaei",
//                       "initials": "DQ",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "iCxpIhgAMjPVX",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51284",
//                       "mode": "viewer",
//                       "name": "Jana BinAli",
//                       "initials": "JB",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "iXnN3zgWvpRx1",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7554",
//                   "name": "51274-51275",
//                   "category": "WA",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51274",
//                       "mode": "viewer",
//                       "name": "Iman Mitwaly",
//                       "initials": "IM",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "QJ5wDpX1s2nUH",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51275",
//                       "mode": "viewer",
//                       "name": "Mora",
//                       "initials": "MO",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "nb3kUMsfSc2dB",
//                       "level": 0
//                   }
//               }
//           ]
//       },
//       {
//           "category": "WB",
//           "categoryLabelEn": "Women B",
//           "categoryLabelAr": "نساء B\r\n",
//           "teams": [
//               {
//                   "id": "6900",
//                   "name": "45170-27788",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45170",
//                       "mode": "viewer",
//                       "name": "Fatmah Abdulhusain",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "27788",
//                       "mode": "viewer",
//                       "name": "Maha Faramarzi",
//                       "initials": "MF",
//                       "picUrl": null,
//                       "rank": "2",
//                       "salt": "qiMaGK9cPWJ07",
//                       "level": "8.5"
//                   }
//               },
//               {
//                   "id": "7191",
//                   "name": "45408-45802",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "45408",
//                       "mode": "viewer",
//                       "name": "Hessa AlAteeqi",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": "6.5"
//                   },
//                   "player2": {
//                       "id": "45802",
//                       "mode": "viewer",
//                       "name": "Lujain AlWazzan",
//                       "initials": "LA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "2.5"
//                   }
//               },
//               {
//                   "id": "7093",
//                   "name": "44815-19880",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "44815",
//                       "mode": "viewer",
//                       "name": "Dalal Almuscati",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK01",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "19880",
//                       "mode": "viewer",
//                       "name": "Dhay Al Hajri",
//                       "initials": "DH",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "27GsmNPfxBlgu",
//                       "level": 8
//                   }
//               },
//               {
//                   "id": "7472",
//                   "name": "51116-51117",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51116",
//                       "mode": "viewer",
//                       "name": "Fajer AlQenai",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "M5Cy4XDbg3U8T",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "47108",
//                       "mode": "viewer",
//                       "name": "Worood Al Dashti",
//                       "initials": "WD",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "qiMaGn9cPWK03",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7221",
//                   "name": "50844-49866",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50844",
//                       "mode": "viewer",
//                       "name": "Najla al eisa",
//                       "initials": "NE",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "RPWUJYKCM1qOi",
//                       "level": "3.5"
//                   },
//                   "player2": {
//                       "id": "49866",
//                       "mode": "viewer",
//                       "name": "Aisha Alawadhi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "bjYsTp2GFqcaM",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7046",
//                   "name": "48178-45816",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "48178",
//                       "mode": "viewer",
//                       "name": "Nouf  Al Amar",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "P79mkobHAQVrT",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "45816",
//                       "mode": "viewer",
//                       "name": "Maha Al Faraj",
//                       "initials": "MF",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": "7.5"
//                   }
//               },
//               {
//                   "id": "7253",
//                   "name": "46387-50520",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "46387",
//                       "mode": "viewer",
//                       "name": "Muneera Al Yahya",
//                       "initials": "MY",
//                       "picUrl": "https://arenabh.live/img/users/46387/202311090824232663400.png",
//                       "rank": "1",
//                       "salt": "qiMaGn9cPWK02",
//                       "level": 7
//                   },
//                   "player2": {
//                       "id": "50520",
//                       "mode": "viewer",
//                       "name": "haya alrefai",
//                       "initials": "HA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "EmLX8ft7rzvuJ",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7255",
//                   "name": "50865-50866",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50865",
//                       "mode": "viewer",
//                       "name": "Aisha Samuels",
//                       "initials": "AS",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "SvN6oFq7RaHPw",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50866",
//                       "mode": "viewer",
//                       "name": "Taif Al Khaldi",
//                       "initials": "TK",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "1dT4bxyqOFsfU",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7357",
//                   "name": "51003-51004",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51003",
//                       "mode": "viewer",
//                       "name": "Anwar alomar ",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "OEIbBkYVF3ZDG",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51004",
//                       "mode": "viewer",
//                       "name": "Shahad Altattan",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "7XpzEARO0cCMn",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7372",
//                   "name": "51012-51013",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51012",
//                       "mode": "viewer",
//                       "name": "Hanan Al Fares ",
//                       "initials": "H",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Nv4R0wznWqkKj",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51013",
//                       "mode": "viewer",
//                       "name": "Jenan Al Fares",
//                       "initials": "JF",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "SFeP0NHUJGlpX",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7471",
//                   "name": "50832-51115",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50832",
//                       "mode": "viewer",
//                       "name": "Veronica",
//                       "initials": "VE",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "fTUZbvLCPit2W",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "51115",
//                       "mode": "viewer",
//                       "name": "Farah AlYaqoub",
//                       "initials": "FA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "eF40Q2MYsnLi7",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7470",
//                   "name": "51112-51113",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51112",
//                       "mode": "viewer",
//                       "name": "Thamra AlShallal",
//                       "initials": "TA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "Ki4x9c16ROQFm",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51113",
//                       "mode": "viewer",
//                       "name": "Dalal AlBassam",
//                       "initials": "DA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "W7GAtFjv1o3aN",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7439",
//                   "name": "50832-51033",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "50832",
//                       "mode": "viewer",
//                       "name": "Veronica",
//                       "initials": "VE",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "fTUZbvLCPit2W",
//                       "level": "7.5"
//                   },
//                   "player2": {
//                       "id": "51033",
//                       "mode": "viewer",
//                       "name": "Farah Yacoub",
//                       "initials": "FY",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "AMK8eoJU4Nqlr",
//                       "level": 6
//                   }
//               },
//               {
//                   "id": "7469",
//                   "name": "51004-51003",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51004",
//                       "mode": "viewer",
//                       "name": "Shahad Altattan",
//                       "initials": "SA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "7XpzEARO0cCMn",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51003",
//                       "mode": "viewer",
//                       "name": "Anwar alomar ",
//                       "initials": "A",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "OEIbBkYVF3ZDG",
//                       "level": 0
//                   }
//               },
//               {
//                   "id": "7467",
//                   "name": "51108-51109",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51108",
//                       "mode": "viewer",
//                       "name": "Aisha AlAwadhi",
//                       "initials": "AA",
//                       "picUrl": null,
//                       "rank": null,
//                       "salt": "zCfVhsPWL9iXk",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "50844",
//                       "mode": "viewer",
//                       "name": "Najla al eisa",
//                       "initials": "NE",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "RPWUJYKCM1qOi",
//                       "level": "3.5"
//                   }
//               },
//               {
//                   "id": "7468",
//                   "name": "51110-51111",
//                   "category": "WB",
//                   "matchesPlayed": null,
//                   "points": null,
//                   "avgRank": 1,
//                   "avgLevel": 0,
//                   "player1": {
//                       "id": "51110",
//                       "mode": "viewer",
//                       "name": "Mais AlAmeeri",
//                       "initials": "MA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "WOF4V2dofNYw3",
//                       "level": 0
//                   },
//                   "player2": {
//                       "id": "51111",
//                       "mode": "viewer",
//                       "name": "Nouf AlSabeeh",
//                       "initials": "NA",
//                       "picUrl": null,
//                       "rank": "1",
//                       "salt": "PFkEHel0NTsrt",
//                       "level": 0
//                   }
//               }
//           ]
//       }
//   ]
// }


